import { faSparkles, faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Markdown } from '@scale/scaleui';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';

interface JustificationSuggestionsContainerProps {
  justification?: string;
  loading?: boolean;
  className?: string;
}

const JustificationSuggestionsContainer: React.FC<JustificationSuggestionsContainerProps> = ({
  justification = '',
  loading,
  className,
}) => {
  return (
    <>
      <div
        className={twMerge(
          'bg-info-50 rounded-lg border border-neutral-300 flex flex-col items-center gap-2 py-2 px-4',
          className,
        )}
      >
        <div className="flex flex-1 flex-row items-center self-start gap-2">
          {loading ? (
            <FontAwesomeIcon icon={faSpinnerThird} className="animate-spin text-info-900" />
          ) : (
            <FontAwesomeIcon icon={faSparkles} className="text-info-900" />
          )}
          <p className="text-info-900">Archie's suggestion</p>
        </div>
        {!loading && <Markdown markdown={justification}></Markdown>}
      </div>
    </>
  );
};

export default memo(JustificationSuggestionsContainer);
